module.exports = __webpack_public_path__ + "img/01b9c93.png";